import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, minValue, requiredIf } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import ageSwitch from '../../../components/forms/component.age-birthdate-input-switch.vue';
import { MainVueOpts } from '../../../main-vue';
import { ibSpinOpts } from '../../../helper-functions/applicationCommonValues';
import {
    isAfterField,
    convertDateByLang,
    monthDate,
    createDateByLangStr,
    createDateByLangApplications,
    numbersWithDashSlash,
    noAlphabets
} from '../../../helper-functions/helper-functions';
import {
    createUpdateApplicationService,
    changeInSessionStorage,
    checkExpiredAndTriggerValidation,
    goToFirstError,
    getItemSessionStorage
} from '../../../helper-functions/services';
import section from '../subcomponents/img/all/section-configs';
import inputSection from '../subcomponents/input-section.vue';
import Step1Mixin from '../mixins/Step1Mixin';
import { IMGPlanIds, imgPlanIds } from './shared';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, Step1Mixin],
    components:{
        'date-picker': datePicker,
        'age-switch': ageSwitch,
        // 'save-share-block' : saveShareBlock,
        'save-share': () => import('../../../components/forms/component.save-share.vue'),
        'input-section': inputSection
    },
    props:['form-data'],
    data: function() {
        return {
            form: {
                homeCountryOption: ibJS.application && ibJS.application.travelerInfos && ibJS.application.travelerInfos.length && ibJS.application.travelerInfos[0].homeCountryOption ? ibJS.application.travelerInfos[0].homeCountryOption : "",
                citizenshipCountry : ibJS.application && ibJS.application.travelerInfos && ibJS.application.travelerInfos.length && ibJS.application.travelerInfos[0].citizenshipCountry ? ibJS.application.travelerInfos[0].citizenshipCountry : "",
                destinationCountry : ibJS.application && ibJS.application.destinationCountries && ibJS.application.destinationCountries.length > 0 ? ibJS.application.destinationCountries[0].country : "",
                homeCountry : ibJS.application && ibJS.application.travelerInfos && ibJS.application.travelerInfos.length && ibJS.application.travelerInfos[0].homeCountry ? ibJS.application.travelerInfos[0].homeCountry : "",
                rules: {
                    residingPrimaryDestCountry: ibJS.application && ibJS.application.appCompanyImg && ibJS.application.appCompanyImg.residingPrimaryDestCountry || null,
                    timeInUs: ibJS.application && ibJS.application.appCompanyImg && ibJS.application.appCompanyImg.residedInUS6months || ibJS.application && ibJS.application.appCompanyImg && ibJS.application.appCompanyImg.residedInUS1month|| null,
                    residedOutsideUS6months: ibJS.application && ibJS.application.appCompanyImg && ibJS.application.appCompanyImg.residedOutsideUS6months || null,
                    heldIntlPlan30days: ibJS.application && ibJS.application.appCompanyImg && ibJS.application.appCompanyImg.heldIntlPlan30days || null,
                    currentHealthPlan: ibJS.application && ibJS.application.appCompanyImg && ibJS.application.appCompanyImg.currentHealthPlan || null
                },
                destInclCostaRica: getItemSessionStorage.call(this,'destInclCostaRica') !== undefined ? getItemSessionStorage.call(this,'destInclCostaRica') : '',
                arrivalDateUS: ibJS.application?.arrivalDateUS || '',
                planId: window.ibJS?.planId || null
            },
            totalChildren: 0,
            formSending: false,
            showTravelerValidation: false,
            countries: ibJS.countries,
            popularCountries: ibJS.popularCountries,
            multiselectFocus : false,
            USandTerritories: ["USA","ASM","GUM","MNP","PRI","UMI","VIR"],
            mexicoAndCanada: ["CAN","MEX"],
            requireRuleError: false,
            section: section,
            submitted: false,
            // plansWithUS1andCRNonUS : [311,319,imgPlanIds.Outreach_America,imgPlanIds.Patriot_America_Platinum],
            // plansWithCRUS : [312,320,imgPlanIds.Outreach_International,imgPlanIds.Patriot_International_Platinum],
            ageGroup: null,
            // showQuestions: getItemSessionStorage('showQuestions') !== undefined ? getItemSessionStorage('showQuestions') === 'true' : false,
            firstClick: 0,
            UserLoggedInMyAcoount: ibJS.UserLoggedInMyAcoount,
            hasChildfromQuote: false,
            hasSpousefromQuote: false,
            currentLang: window.globalLanguage.lang,
            setDate: '',
            imgPlanId: new IMGPlanIds()
        }
    },
    validations: function(){
        var validations = {
            form:{
                startDate: {
                    required,
                    checkDateFormat,
                    numbersWithDashSlash,
                    noAlphabets
                },
                endDate: {
                    required,
                    checkDateFormat,
                    isAfterStartDate: isAfterField('startDate',this.submitted),
                    numbersWithDashSlash,
                    noAlphabets
                },
                destinationCountry:{
                    required
                },
                citizenshipCountry:{
                    required
                },
                homeCountry: {
                    required
                },
                travelerInfos:{
                    $each:{
                        age:{
                            requiredOnlyPrimary,
                            requiredChild,
                            childAge,
                            requiredAdditional,
                            minValue: minValue(0)
                        }
                    }
                },
                destInclCostaRica:{},
                arrivalDateUS: {
                    required: requiredIf(form => this.form.planId === imgPlanIds.Visitors_Protect),
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                }
                // rules: {} // donot remove even if empty array. required to push rule validations from vue component
            }
        };

        function requiredOnlyPrimary(x,a){
            return !((a.travelerType === 'primary' || a.travelerType === '') && (x === '' || x === null));
        }

        function childAge(x,a){
            return a.travelerType === 'child' && x !== undefined && x > 17 && [imgPlanIds.Patriot_Exchange_Program, imgPlanIds.Student_Health_Advantage_Standard, imgPlanIds.Student_Health_Advantage_Platinum].indexOf(this.form.planId) === -1  ? false
                : !(a.travelerType === 'child' && x !== undefined && x > 18);
        }

        function requiredChild(x,a) {
            if(!this.hasChildfromQuote) {
                return this.form.travelerInfos.length > 3 && a.travelerType === 'child' && (x === '' || x === null) ? false : true;
            } else {
                return a.travelerType === 'child' && (x === '' || x === null) ? false : true;
            }
        }

        function requiredAdditional(x,a) {
            if(this.hasSpousefromQuote &&  a.travelerType === 'spouse') {
                return (x === '' || x === null) ? false : true;
            } else {
                return true;
            }
        }

        function checkDateFormat(x){
            return !(monthDate(x) === false && !this.hideDateError);
        }

        if(this.hasDestCostaRica && this.form.destInclCostaRica=='') {
            validations.form.destInclCostaRica.required = required;
        } else {
            delete validations.form.destInclCostaRica.required;
        }

        return validations;
    },
    mounted:function(){
        if(this.form.planId === imgPlanIds.Patriot_America_Plus) {
            this.form.destinationCountry = "USA";
        }

        // if(this.form.planId === 320) {
        //     this.form.citizenshipCountry = "USA";
        //     this.form.homeCountry = "USA";
        //     this.disableInput();
        // }
        convertDateByLang(this.form,window.globalLanguage.lang);
    },
    created: function(){
        var self = this;
        // when the user comes back to step 1 after going to step 2 or beyond

        // this.showQuestions = this.showRuleQuestions !== '';
        // setItemSessionStorage('showQuestions', this.showQuestions);
        // if(this.showQuestions) {
        //     this.firstClick = 1;
        // }
        if(self.application != null){
            if(this.application.travelerInfos !== null && this.application.travelerInfos.length) {
                self.form.travelerInfos =[];
                /* only primary and spouse have age value*/
                let ageGreaterThanZero = 0;
                for(var i=0;i<self.application.travelerInfos.length;i++){
                    var travelerType = self.application.travelerInfos[i].travelerType || '';
                    if(travelerType === 'spouse' && i != 1 && self.application.travelerInfos[1] && self.application.travelerInfos[1].travelerType === 'spouse') {
                        travelerType = 'child';
                    }
                    var newTraveler = {
                        age: self.application.travelerInfos[i].age,
                        tripCost: null,
                        quotePrice:null,
                        travelerType:travelerType
                    };
                    this.setTravelerRiderSelections(newTraveler, self.application.travelerInfos[i]);

                    self.form.travelerInfos.push(newTraveler);
                    if(self.application.travelerInfos[i] && self.application.travelerInfos[i].travelerType=='child' && self.form.travelerInfos[i].age==-1) {
                        this.hasChildfromQuote = true;
                    }

                    if(self.application.travelerInfos[i] && self.form.travelerInfos[i].age > 0) {
                        ageGreaterThanZero += 1;
                    }
                }
                // if(ageGreaterThanZero === 2) {
                //     this.hasSpousefromQuote = true;
                // }
                if(self.isMobile && self.form.travelerInfos.length > 1) {
                    let spouseTravelers = self.form.travelerInfos.filter(traveler => traveler.travelerType === 'spouse');
                    if(spouseTravelers.length == 0) {
                        let newTraveler = {
                            age: null,
                            tripCost: null,
                            quotePrice:null,
                            travelerType: 'spouse'
                        };
                        this.setTravelerRiderSelections(newTraveler);
                        self.form.travelerInfos.splice(1, 0, newTraveler);
                    }
                }
            }
            self.travelersOpened = true;
            for(var i=0;i<self.form.travelerInfos.length;i++){
                if(self.form.travelerInfos[i].age === -1){
                    self.form.travelerInfos[i].age=null;
                    self.showChildErrorText=true;
                    self.showTravelers=true;
                }
            }

            // Object.keys(self.form.rules).forEach(key => {
            //     self.form.rules[key] === 'yes' ? self.form.rules[key] =  true : self.form.rules[key] === 'no' ? self.form.rules[key] = false : null;
            // });
            this.initialSumChildren();
        }
        else {
            self.form.travelerInfos[0].travelerType = 'primary';
            self.form.travelerInfos.splice(2,1);
            if(self.form.travelerInfos[1]) self.form.travelerInfos[1].travelerType = 'spouse';
            if(!self.isMobile) this.addChild();
        }

        if(this.application && (this.application.travelerInfos === null || !this.application.travelerInfos.length)) {
            self.form.travelerInfos[0].travelerType = 'primary';
            if(self.form.travelerInfos[1]) self.form.travelerInfos[1].travelerType = 'spouse';
            if(self.form.travelerInfos[2]) self.form.travelerInfos[2].travelerType = 'child';
        }

        let needChild = true;
        let needSpouse = true;
        for (var i = 1; i < self.form.travelerInfos.length; i++) {
            if (self.form.travelerInfos[i].travelerType === 'spouse') {
                needSpouse = false;
            }
            else if (self.form.travelerInfos[i].travelerType === 'child') {
                needChild = false;
            }
            if(needChild === false && needSpouse === false) {
                break;
            }
        }

        if(self.isMobile) {
            needChild = false;
            needSpouse = false;
        }

        if (needChild) {
            this.addChild();
        }
        if (needSpouse) {
            this.addSpouse();
        }

        // this.ageGroup = this.computeMaxMonths;

        checkExpiredAndTriggerValidation.call(this);

        $(document).ready(function () {
            $('.o-Form').on('click', function () {
                self.showTravelers = false;
            });

            $('.js-Stop-propagation').on('click', function (e) {
                e.stopPropagation();
            });
        });

        const todaysDate = new Date();
        this.setDate = new Date(`${todaysDate.getMonth()+1}/${todaysDate.getDate()}/${todaysDate.getFullYear()}`);

        if([742, 751, 755, 744, 747, 748, 749, 406, 421, 546, 532].indexOf(Number(this.formData.planId)) > -1 && this.form.destinationCountry == "") {
            this.form.destinationCountry = "USA";
        }
    },
    computed:{
        showMobileError: function() {
            if(this.showRuleQuestions) {
                return this.$v.form.$error && this.$v.form.rules.$error;
            }
            return this.$v.form.$error;
        },
        selectMultiple:function(){
            return true;
        },
        countriesList: function() {
            var countryList = [];
            if (this.popularCountries.length) {
                for (var i = 0, countryLen = this.popularCountries.length; i < countryLen; i++) {
                    var countryText = this.popularCountries[i].country || null;
                    var countryValue = this.popularCountries[i].value || null;

                    var newCountry = {
                        name: countryText,
                        country: countryValue
                    };
                    countryList.push(newCountry);
                }

                if (this.countries.length) {
                    for (var i = 0, countryLen = this.countries.length; i < countryLen; i++) {
                        var countryText = this.countries[i].country || null;
                        var countryValue = this.countries[i].value || null;

                        var newCountry = {
                            name: countryText,
                            country: countryValue
                        };

                        countryList.push(newCountry);
                    }
                }
                return countryList;
            }
        },
        // computeMaxMonths: function(){
        //     return this.form.travelerInfos.filter(traveler => traveler.age > 65).length > 0  ? 1 : 6;
        // },
        USandTerritoriesDropdown:function(){
            let countryList = [];

            if (this.countries.length) {
                for (let i = 0, countryLen = this.countries.length; i < countryLen; i++) {

                    let newCountry = {
                        country: this.countries[i].value || null,
                        name: this.countries[i].country || null
                    };

                    if (this.USandTerritories.indexOf(newCountry.country) > -1) {
                        countryList.push(newCountry);
                    }
                }
            }
            return countryList;
        },
        UsMexicoAndCanda () {
            let countryList = [];
            if (this.countries.length) {
                const UsMexicoAndCanada = [...this.USandTerritories, ...this.mexicoAndCanada];
                for (let i = 0, countryLen = this.countries.length; i < countryLen; i++) {

                    let newCountry = {
                        country: this.countries[i].value || null,
                        name: this.countries[i].country || null
                    };

                    if (UsMexicoAndCanada.indexOf(newCountry.country) > -1) {
                        countryList.push(newCountry);
                    }
                }
            }
            countryList.sort((a,b)=>a.name-b.name);
            return countryList;
        },
        hasDestCostaRica() {
            // return this.form.destinationCountry === 'CRI';
            return false;
        },
        costaRicaRestriction() {
            if (this.hasDestCostaRica && this.form.destInclCostaRica === 'No') return true;
        }
        // showRuleQuestions: function() {
        //     return new imgRules(this.form.destinationCountry, this.form.citizenshipCountry, this.form.planId, this.USandTerritories).currentRule();
        // },
        // inside the US rule ( US1 )
        // q2: function() {
        //     return  this.form.travelerInfos[0].age &&
        //         this.form.travelerInfos[0].age.toString().length > 0 &&
        //         this.form.rules.residingPrimaryDestCountry === true &&
        //         this.USandTerritories.indexOf(this.form.destinationCountry) > -1 &&
        //         this.plansWithUS1andCRNonUS.indexOf(this.form.planId) > -1;
        // },
        // outside the US rule ( CR-US )
        // q3: function() {
        //     return this.form.rules.residingPrimaryDestCountry === false &&
        //         !this.$v.form.rules.ruleUS1 &&
        //         this.USandTerritories.indexOf(this.form.citizenshipCountry) > -1 &&
        //         this.plansWithCRUS.indexOf(this.form.planId) > -1;
        // },
        // health plan in force rule ( CR-US )
        // q4: function() {
        //     return this.form.rules.residedOutsideUS6months &&
        //         !this.form.rules.residingPrimaryDestCountry;
        // },
        // insurance needs replacing rule ( US1 )
        // q5: function() {
        //     return this.form.rules.timeInUs &&
        //         this.form.rules.residingPrimaryDestCountry &&
        //         this.q2;
        // },
        // showCountryOfResidenceField() {
        //     return homeCountryPlans.indexOf(this.form.planId) === -1;
        // }
    },
    watch:{
        'form.endDate': function(){
            this.createDate();
        },
        'form.startDate' : function(){
            this.createDate();
        },
        'form.citizenshipCountry': function() {
            this.sameHomeAndCitizenship();
        },
        'form.destInclCostaRica' : function(val) {
            changeInSessionStorage.call(this,'destInclCostaRica',this.form.destInclCostaRica);

            if(val === 'No' && ibJS.affiliateValues.trawickTripCanNW) {
                window.location.href = window.qResultsLang.costaRicaLanding;
            }
        }
    },
    methods: {
        setTravelerRiderSelections(traveler, savedTraveler = {}) {
            if(!traveler) return traveler;

            const selectedValue = value => String(value).toLowerCase() === 'yes' ? 'yes' : 'no';
            traveler.imgEvacPlusRider = selectedValue(savedTraveler.imgEvacPlusRider);
            traveler.imgDeviceProtectionRider = selectedValue(savedTraveler.imgDeviceProtectionRider);

            return traveler;
        },
        createQuote: function () {
            this.$v.$touch();

            //Tells step 3 when to clear state field
            let addressDropdownCountries = ['USA','IND','CAN','AUS','PYF','ANT','GBR','VIR'];

            if(this.application && this.application.homeCountryAddress) {
                if(addressDropdownCountries.indexOf(this.application.homeCountryAddress.country) !== addressDropdownCountries.indexOf(this.form.homeCountry)) {
                    try{window.sessionStorage['clearStateS3'] = true}catch(e){};
                }
                else {
                    try{window.sessionStorage['clearStateS3'] = false}catch(e){};
                }
            }

            this.form.travelerInfos[0].citizenshipCountry =  this.form.citizenshipCountry;
            this.form.travelerInfos[0].homeCountry =  this.form.homeCountry;
            this.form.destinationStr = [];
            this.form.destinationStr.push(this.form.destinationCountry);

            for(var i=0;i<this.form.travelerInfos.length;i++){
                var travelerType = this.form.travelerInfos[i].travelerType || '';
                if(travelerType === 'spouse' && i != 1 && this.form.travelerInfos[1] && this.form.travelerInfos[1].travelerType === 'spouse') {
                    travelerType = 'child';
                }
                this.form.travelerInfos[i].travelerType = travelerType;
            }

            // special condition to check set the timeInUs entity as the backend has separate entities for 6 months and 1 month

            var quoteResultsURL='/api/'+ibJS.productName+'/quote-results/?lang='+window.globalLanguage.lang;

            if (!this.$v.$invalid && !this.costaRicaRestriction) {

                this.showQuestions = this.showRuleQuestions !== '';

                Vue.nextTick(() => {
                    // let ruleCheck = this.checkIfRuleRequired();
                    // this.firstClick ++;
                    // let questionsParent = document.getElementById('questions-parent')
                    // if((ruleCheck && questionsParent.style.display === 'none') || !this.requireRuleError){

                        let spinTarget=this.$refs.btnSpinnerModal;
                        let spinner = new IBSpinner(ibSpinOpts).spin(spinTarget);

                        // this.transformRulesArray();
                        this.spliceTravelers();

                        var _this = this;
                        Vue.nextTick(() => {

                            let langBasedData = Object.assign({}, this.form);
                            createDateByLangApplications(langBasedData, window.globalLanguage.lang);
                            createUpdateApplicationService.call(this, quoteResultsURL, langBasedData, 'application');
                            this.submitted = true;
                        });
                        this.submitted = false;

                    // }
                    // else if(!ruleCheck) {
                    //     Vue.nextTick(() => this.$v.form.rules.$reset() );
                    // }
                })
            }
            else {
                Vue.nextTick(() => goToFirstError() );
            }
        },
        // checkIfRuleRequired: function(){
        //     //order of questionVariables must match the order of questions on the HTML page
        //     let questionVariables = ['residingPrimaryDestCountry',
        //         'timeInUs',
        //         'residedOutsideUS6months',
        //         'currentHealthPlan',
        //         'heldIntlPlan30days'];
        //     let questions = document.getElementsByClassName('index-questions');
        //     let returnedValue = true;
        //
        //     Array.prototype.forEach.call(questions,(x,i) => {
        //         if (x.style.display !== 'none' && this.showQuestions && this.form.rules[questionVariables[i]] == null) {
        //             this.requireRuleError = true;
        //             returnedValue =  false;
        //         }
        //     });
        //     return returnedValue;
        //
        // },
        // maxMonths: function() {
        //     if((this.computeMaxMonths !== this.ageGroup && this.ageGroup !== null) && this.q2){
        //         this.clearQuestions();
        //     }
        //     this.ageGroup =  this.computeMaxMonths;
        // },
        // transformRulesArray: function(){
        //     this.form.appCompanyImg = {};
        //     this.form.rules.residedInUS1month = null;
        //     this.form.rules.residedInUS6months = null;
        //     if(this.form.travelerInfos.filter(traveler =>{return traveler.age > 65}).length > 0){
        //         this.form.rules.residedInUS1month = this.form.rules.timeInUs;
        //     }
        //     else{
        //         this.form.rules.residedInUS6months = this.form.rules.timeInUs;
        //     }
        //
        //     this.form.appCompanyImg = Object.assign({},this.form.rules);
        //
        //     Object.keys(this.form.appCompanyImg).forEach(key => {
        //         this.form.appCompanyImg[key] == true ? this.form.appCompanyImg[key] =  'yes' : this.form.appCompanyImg[key] == false ? this.form.appCompanyImg[key] = 'no' : null;
        //     });
        //
        //     delete this.form.appCompanyImg.timeInUs;
        // },
        disableInput(){
            if(document.getElementById('homeCountrySelect')) {
                let homeCountryDropdown = document.getElementById('homeCountrySelect');
                if(homeCountryDropdown) {
                    homeCountryDropdown.disabled = true;
                    homeCountryDropdown.style.backgroundColor = "#f4f4f4";
                    homeCountryDropdown.style.cursor = 'initial';
                    homeCountryDropdown.style.backgroundImage = 'none';
                }
            }

        },
        sameHomeAndCitizenship: function() {
            //add patriot multitrip international
            if([312,imgPlanIds.Outreach_International, 404, imgPlanIds.GlobeHopper_Senior_Single_Trip, imgPlanIds.GlobeHopper_Senior_Multi_Trip].indexOf(this.form.planId) > -1 &&
                this.USandTerritories.indexOf(this.form.citizenshipCountry) > -1) {
                this.disableInput();
                this.form.homeCountry = this.form.citizenshipCountry;
            }
            else if(document.getElementById('homeCountrySelect')){
                let homeCountryDropdown = document.getElementById('homeCountrySelect');
                if(homeCountryDropdown) {
                    homeCountryDropdown.disabled = false;
                    homeCountryDropdown.style.backgroundColor = "white";
                    homeCountryDropdown.style.cursor = 'pointer';
                }
            }
        },
        initialSumChildren: function(){
            for(let i in this.form.travelerInfos) {
                if(this.form.travelerInfos[i].travelerType === 'child') {
                    this.totalChildren ++;
                }
            }
        },
        sumChildren: function(x) {
            x === true ? this.totalChildren ++ : this.totalChildren --;
        },
        // checkQuestionDisplay(){
        //     //Makes variable associated with rule questions reset to null if display is none.
        //
        //     this.requireRuleError = false;
        //     //order of questionVariables must match the order of questions on the HTML page
        //     let questionVariables = ['residingPrimaryDestCountry',
        //         'timeInUs',
        //         'residedOutsideUS6months',
        //         'currentHealthPlan',
        //         'heldIntlPlan30days'];
        //     let questions = document.getElementsByClassName('index-questions');
        //     Vue.nextTick(() => {
        //         Array.prototype.forEach.call(questions,(x,i) => {
        //             if (x.style.display === 'none') {
        //                 this.form.rules[questionVariables[i]] = null;
        //             }
        //         });
        //     });
        // },
        // clearQuestions: function() {
        //     let currentRule = new imgRules(this.form.destinationCountry,
        //         this.form.citizenshipCountry,
        //         this.form.planId,
        //         this.USandTerritories).currentRule();
        //     if(currentRule !== 'RuleCR-US' ||
        //         (currentRule === 'RuleCR-US' && this.USandTerritories.indexOf(this.form.destinationCountry) === 0)) {
        //         ['residingPrimaryDestCountry',
        //             'timeInUs',
        //             'residedOutsideUS6months',
        //             'currentHealthPlan',
        //             'heldIntlPlan30days'].forEach( x => this.form.rules[x] = null);
        //         this.requireRuleError = false;
        //     }
        //     this.firstClick = 0;
        // },
        // setShowQuestionsFalse: function() {
        //     if(this.USandTerritories.indexOf(this.form.destinationCountry) === -1) this.showQuestions = false;
        // },
        createDate: function(){
            if(this.form.startDate!='' && this.form.endDate!=''){
                var startDate = createDateByLangStr(this.form.startDate,'en');
                var endDate = createDateByLangStr(this.form.endDate,'en');
            }
        },
        toggleTravelers: function () {
            this.showTravelers = !this.showTravelers;
            this.travelersOpened = true;
        },
        addTraveler: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:''
            };
            this.form.othersListArray.push(newTraveler);
        },
        addChild: function(){
            let isChild = this.form.travelerInfos.length >= 2;
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType: isChild ? 'child' : 'spouse'
            };
            this.setTravelerRiderSelections(newTraveler);
            this.form.travelerInfos.push(newTraveler);
            if(isChild) this.sumChildren(true);
        },
        addSpouse: function() {
            var newTraveler = {
                tripCost: null,
                age: null,
                travelerType:'spouse'
            };
            this.setTravelerRiderSelections(newTraveler);
            this.form.travelerInfos.splice(1,0,newTraveler);
        },
        resetAgeValidation: function(index){
            this.showChildErrorText = false;
            if(this.form.travelerInfos[index] && !(/^\d+$/.test(this.form.travelerInfos[index].age))){
                this.form.travelerInfos[index].age=null;
            }
        }
    }
};
